export enum favRestaurantActionsTypes {
    GET_FAV_RESTAURANT = 'GET_FAV_RESTAURANT',
    GET_FAV_RESTAURANT_SUCCESS = 'GET_FAV_RESTAURANT_SUCCESS',
    GET_FAV_RESTAURANT_FAILURE = 'GET_FAV_RESTAURANT_FAILURE',
  }
  